import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout-Route fuer /mitarbeiter. Reine Wrapper-Komponente — Listen-Inhalt liegt in
 * mitarbeiter.index.tsx, Detail-/Form-Routen (mitarbeiter.$id.tsx, mitarbeiter.neu.tsx) werden ueber
 * den Outlet hier gerendert.
 *
 * Vorher hatte mitarbeiter.tsx selbst die Listen-Komponente — TanStack file-based
 * Routing hat sie aber als Parent fuer die Child-Routen erkannt. Ohne Outlet
 * sind Children nie gerendert; Klick auf "/mitarbeiter/neu" zeigte still die Liste.
 */
export const Route = createFileRoute('/mitarbeiter')({
  component: MitarbeiterLayout,
});

function MitarbeiterLayout() {
  return <Outlet />;
}
